export const sprintsKeys = {
  all: ["sprints"] as const,
  list: () => [...sprintsKeys.all, "list"] as const,
};
